<template>
  <a :href="supplierURL" target="_blank">
    <article>
      <div class="resort-item resort-item-large">
        <div>
          <image-with-fallback
            class="resort-image rounded"
            :src="getCloudinaryImage(programme.__odyssey_thumbnail)"
            :alt="programme.__odyssey_supplier_info.name" />
        </div>

        <div>
          <h4 class="fs-20 font-medium">
            <span v-html="programme.__odyssey_programme_name" />
          </h4>
          <p class="mt-1 text-black-light-5 fs-14">
            <span v-html="programme.__odyssey_supplier_info.name"></span>, 
            <span v-html="location"></span>
          </p>
          <div class="mt-4 text-black-light-5">
            <ul class="list-reset flex">
              <li v-for="(incl, index) in inclusions" :key="incl.id">
                <span :class="{ 'line-through': incl.type === 'not_included' }">
                  {{ incl.name }}
                </span>
                <span class="mx-2" v-if="index !== inclusions.length - 1">•</span>
              </li>
            </ul>
          </div>
          <div class="mt-4" v-html="programme.__odyssey_Tagline" />

          <div class="mt-4 flex items-center">
            <div class="flex-none">
              <svg width="24" height="24" class="inline-block">
                <use xlink:href="/img/sprite.svg#ic_clock"></use>
              </svg>
              {{ tripLength }}
            </div>
            <span class="mx-2">•</span>
            <div class="flex-none" :class="{ 'opacity-50': hasDiving === false }">
              <svg width="24" height="24" class="inline-block">
                <use xlink:href="/img/sprite.svg#ic_diving"></use>
              </svg>
              <span :class="{ 'line-through': hasDiving === false }">Diving</span>
            </div>

            <div class="flex-1 text-right">
              <span class="font-medium fs-20">
                <currency-context>
                  <template v-slot="{ convert }">
                    <span
                      v-text="convert(tripPrice)"
                    ></span>
                  </template>
                </currency-context>
              </span> {{ pricingBasis }}
            </div>
          </div>
        </div>
      </div>
    </article>
  </a>
</template>

<script>
import get from 'lodash/get'
import ImageWithFallback from '../core/ImageWithFallback'
import {
  getProgrammeLength
} from '../../helpers/ecoventureSearchHelpers'
import { getCloudinaryUrl } from "../../helpers";
import {
  ECOVENTURE_CATEGORIES,
  ECOVENTURE_BASIC_INCLUSIONS
} from '../../helpers/constants'
import CurrencyContext from "../core/CurrencyContext";

export default {
  components: {
    ImageWithFallback,
    CurrencyContext
  },
  props: ['programme'],
  computed: {
    supplierURL () {
      return this.programme.__odyssey_resort_url + window.location.search
    },
    location () {
      const destination = get(this.programme, ['__odyssey_destination_programme', 0, 'name'])
      const country = get(this.programme, ['__odyssey_country_programme', 0, 'name'])

      return `${destination}, ${country}`
    },
    tripLength () {
      return getProgrammeLength(this.programme)
    },
    tripPrice () {
      if (this.programme.__odyssey_category === ECOVENTURE_CATEGORIES.EXPEDITION) {
        return this.programme.__odyssey_price
      }
      return this.programme.__odyssey_price_per_week
    },
    pricingBasis () {
      if (this.programme.__odyssey_category === ECOVENTURE_CATEGORIES.EXPEDITION) {
        return '/trip'
      }

      return '/week'
    },
    hasDiving () {
      const divingIncl = ECOVENTURE_BASIC_INCLUSIONS.find(incl => incl.is_diving)

      return this.programme.__odyssey_inclusions.some(incl => {
        return divingIncl.id === incl.id
      })
    },
    inclusions () {
      const basicInclusionsWithoutDiving = ECOVENTURE_BASIC_INCLUSIONS.filter(incl => {
        return incl.is_essential === true
      })
      const result = []

      for (const incl of basicInclusionsWithoutDiving) {
        const hasThisBasicInclusion = this.programme.__odyssey_inclusions.some(_incl => {
          return _incl.id === incl.id
        })

        if (hasThisBasicInclusion) {
          result.push({
            ...incl,
            type: 'included'
          })
        }
        else {
          result.push({
            ...incl,
            type: 'not_included'
          })
        }
      }

      return result
    }
  },
  methods: {
    getCloudinaryImage(url){
      return getCloudinaryUrl(url)
    }
  }
}
</script>
